import { useState, useEffect, useSyncExternalStore } from 'react';

// TODO useSyncExternalStore
function useSessionStorage(key, defaultValue = null) {
  const fromStorageSerialized = window.sessionStorage.getItem(key);

  const deserializedOrDefaultValue = fromStorageSerialized === null
    ? defaultValue
    : JSON.parse(fromStorageSerialized);

  const [value, setValue] = useState(deserializedOrDefaultValue);

  useEffect(() => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

export { useSessionStorage };
